import actions from './actions';

const {FETCH_USER, FETCH_USERS, RESET_USER, FETCH_USER_SUBSCRIPTIONS, FETCH_USER_PROFILE_INFORMATION} = actions;
const initState = {
    users: {
        page: 0,
         perPage: 35,
        data: [],
        total: 0
    },
    user: null,
    userSubscriptions: {
        data: [],
        loading: false,
        error: null
    },
    userProfileInformation: {}
};

const UserReducer = (state = initState, action) => {
    const {type, data} = action;
    switch (type) {
        case FETCH_USERS:
            return {
                ...state,
                users: data,
            };
        case RESET_USER:
            return {
                ...state,
                user: initState.user
            };
        case FETCH_USER: {
            return {
                ...state,
                user: data
            }
        }
        case FETCH_USER_PROFILE_INFORMATION: {
            return {
                ...state,
                userProfileInformation: data
            }
        }
        case FETCH_USER_SUBSCRIPTIONS: {
            return {
                ...state,
                userSubscriptions: {
                    ...state.userSubscriptions,
                    data: data, // This is the array from your API
                    loading: false
                }
            }
        }
        default:
            return state;
    }
};

export default UserReducer;
